import DownloadTicketsMenu from 'app/pages/OrderConfirmationPage/DownloadTicketsMenu';
import { DownloadLinks } from 'app/pages/RegistrationFormPage';
import { Info } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { API_REQUEST_STATUS_SUCCESS } from 'utils/static/constants';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import AddTicketToAppleWallet from 'app/pages/OrderConfirmationPage/AddTicketToAppleWallet';

interface RegistrationFormDownloadTicketProps {
  ticketDoesntHaveDefaultRegistrationFormsValues: boolean;
  requestStatus: string;
  downloadLinks: DownloadLinks | null;
}

const RegistrationFormDownloadTicket: React.FC<
  RegistrationFormDownloadTicketProps
> = ({
  ticketDoesntHaveDefaultRegistrationFormsValues,
  requestStatus,
  downloadLinks,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mt-[16px]">
      {ticketDoesntHaveDefaultRegistrationFormsValues &&
      requestStatus !== API_REQUEST_STATUS_SUCCESS ? (
        <Alert className="bg-neutral-20">
          <Info size={16} />
          <AlertTitle>{t('registrationFormsPage.headerAlertTitle')}</AlertTitle>
          <AlertDescription>
            {t('registrationFormPage.alertAboutCompletingForm')}
          </AlertDescription>
        </Alert>
      ) : downloadLinks ? (
        <div className="flex items-center gap-2 w-fit">
          <AddTicketToAppleWallet link={downloadLinks.pkpass} />
          <DownloadTicketsMenu download={downloadLinks} />
        </div>
      ) : (
        <Alert className="bg-neutral-20">
          <Info size={16} />
          <AlertTitle>{t('orderConfirmationPage.orderConfirmed')}</AlertTitle>
          <AlertDescription>
            {t('registrationFormPage.alertAboutPaymentPending')}
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};

export default RegistrationFormDownloadTicket;
